import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { Role } from '@zakat/shared';
import { EmptyState, Icon, ListSkeleton } from '@/components/ui';
import { hasRole, useAuthStore } from '@/stores/auth';

/** Protège une page : redirige vers la connexion puis revient à la page demandée. */
export function RequireAuth({ children, roles }: { children: ReactNode; roles?: Role[] }) {
  const { user, restored } = useAuthStore();
  const location = useLocation();
  if (!user && !restored) return <ListSkeleton rows={3} />;
  if (!user) {
    const login = location.pathname.startsWith('/admin') ? '/admin/connexion' : '/connexion';
    return <Navigate to={`${login}?retour=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }
  if (roles && !hasRole(user, ...roles)) return <EmptyState icon={<Icon name="lock" size={36} />} title="Accès réservé" description="Votre compte n’a pas les droits nécessaires pour cette page." />;
  return <>{children}</>;
}
